export default __webpack_public_path__ + "static/media/btn_step_4_active.8fb35fb4.svg";